import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { seoArticles } from "@/mocks/articles";

export default function ArticlesListSection() {
  const { t } = useTranslation();

  return (
    <section id="artykuly" className="w-full py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/50 text-xs font-medium text-foreground-500 tracking-wide mb-4">
            SEO Content
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t("articlesList.heading")}
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            {t("articlesList.subheading")}
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden cursor-pointer hover:border-background-300 transition-all"
            >
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                {/* Read time badge */}
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line text-[10px]"></i>
                    {article.readTime}
                  </span>
                </div>

                <h3 className="font-semibold text-foreground-900 text-sm md:text-base group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {article.title}
                </h3>

                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.description}
                </p>

                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t("articlesList.readMore")}
                  <i className="ri-arrow-right-line text-[10px] group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* View all CTA */}
        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600"
          >
            Przejdź do kakobuy spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}